export class AgendaTranslation
{
    id: number;
    locale: string;
    title: string;
    description: string;
}
